// Legacy file - now using enhanced analytics from useAnalytics.js
import { usePageTracking as useEnhancedPageTracking } from './hooks/useAnalytics';

const usePageTracking = () => {
  // Use the enhanced page tracking that includes both GA4 and Mixpanel
  useEnhancedPageTracking();
};

export default usePageTracking;